import {
	PROF,
	REQUESTING,
} from '../constants';
import {checkForwardMatch} from '../logics/utility';

const initialState = {
	id : null,
	uid: null,
	userName: null,
	twitterId:'',
	fetchingState: PROF.NONE,
	comment : '',
	favs:[],
	thumbs:[], // will be deleted
	observers : {},
	imageUrl : '',
	uploadProgress : 0,
	error : null
};

function handleRestAction(state, action) {
	
	const {fetchingState} = action.payload;

	if(fetchingState === REQUESTING.FETCHING){
		const baseState = {
			...state,
			fetchingState,
			error : null,
			errorMessage : null,
		};
		switch (action.type) {
		case PROF.UPLOAD_IMAGE:
		{
			return {
				...baseState,
				uploadProgress : action.payload.progress,
			};
		}
		default:
			return baseState;
		}
	}
	if(fetchingState === REQUESTING.FAIL){
		const {error,message} = action.payload;
		return {
			...state,
			fetchingState,
			error,
			errorMessage : message
		};
	}
	if(fetchingState === REQUESTING.LOADED){
		switch (action.type) {
		case PROF.READ_PROFILE:
		{
			return {
				...state,
				id : action.payload.id,
				fetchingState:action.type,
				...action.payload
			};
		}
		case PROF.INIT_PROFILE:
		{
			return initialState;
		}
		default:
			return state;
		}
	}
	return state;
}

export default function(state = initialState, action){
	if(!checkForwardMatch(action.type,PROF.PREFIX)){
		return state;
	}
	const {payload} = action;
	if(payload && payload.fetchingState){
		return handleRestAction(state, action);
	}
	return state;
}